/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Station_Work_Guests_SuffixInputs */

const vi_station_work_guests_suffix = /** @type {(inputs: Station_Work_Guests_SuffixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} khách`)
};

/**

* @param {Station_Work_Guests_SuffixInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_guests_suffix = /** @type {((inputs: Station_Work_Guests_SuffixInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_Guests_SuffixInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_guests_suffix(inputs)
});